import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import './ConfirmDeleteModal.css';

/**
 * ConfirmDeleteModal
 *
 * Props:
 *   message  – string shown in the body (default: "Are you sure you want to delete this item?")
 *   onConfirm – called when user clicks "Delete"
 *   onCancel  – called when user clicks "Cancel" or the backdrop
 */
const ConfirmDeleteModal = ({ message, onConfirm, onCancel, isLoading = false }) => (
    <div className="cdm-overlay" onClick={isLoading ? undefined : onCancel}>
        <motion.div
            className="cdm-box"
            initial={{ opacity: 0, scale: 0.92, y: -8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: -8 }}
            onClick={e => e.stopPropagation()}
        >
            <div className="cdm-icon-wrap">
                <AlertTriangle size={22} className="cdm-icon" />
            </div>

            <h3 className="cdm-title">Delete Confirmation</h3>

            <p className="cdm-message">
                {message || 'Are you sure you want to delete this item? This action cannot be undone.'}
            </p>

            <div className="cdm-actions">
                <button className="cdm-btn-delete" onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? 'Deleting...' : 'Delete'}
                </button>
                <button className="cdm-btn-cancel" onClick={onCancel} disabled={isLoading}>
                    Cancel
                </button>
            </div>
        </motion.div>
    </div>
);

export default ConfirmDeleteModal;
